// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2F5KQ","title":"Header_title__2lkXU","left":"Header_left__4ndzW","clinicName":"Header_clinicName__2FNtM"};